$('.logo-slider').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  arrows:false,
  speed: 1000,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1290,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
        {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
        {
      breakpoint: 420,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// <script
//   src="https://code.jquery.com/jquery-3.6.0.min.js"
//   integrity="sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4="
//   crossorigin="anonymous">
//     </script>


 

  $( document ).ready(function() {
   
  htmll = '<div class="cstm-bannerimg"><img src="https://cdn.shopify.com/s/files/1/0628/2919/9598/files/hop-banner-4_8b9bc02d-af1a-4431-bc53-b210c9279633.jpg?v=1646633411" /></div>';
$('.snize-filters-sidebar.snize-product-filters').append(htmll);
  });  
  
  
  $( document ).ready(function() {
  html2 = '<div class="cstm-bannerimg"><img src="https://cdn.shopify.com/s/files/1/0628/2919/9598/files/b9_984ba541-11e4-414f-82bd-a7cfad4609e3.jpg?v=1646638543" /></div>';
  $('.snize-three-columns').before(html2);
  });







